import PropTypes from 'prop-types'
import {
  buttonTypeOptions,
  buttonVariantOptions,
  buttonVariantComponentOptions
} from './constants'
import { PrimaryButton } from './styled-components'
import { forwardRef } from 'react'
import { Link } from 'react-router-dom'

import { SpinnerWhite } from '../icons/special'

const ButtonComponent = forwardRef(
  (
    {
      as,
      to = null,
      target = null,
      variant,
      side,
      size,
      emphasis,
      buttonType,
      fullWidth,
      isLoading = false,
      children,
      disableIconStyle = false,
      ...props
    },
    ref
  ) => {
    const isVariantLink = variant === 'link'

    const isLink = variant === 'link' || as === Link || as === 'a'

    const isExternalLink =
      isLink && (to?.startsWith('http') || to?.startsWith('https'))

    const Component = buttonVariantComponentOptions[variant] || PrimaryButton

    const contentChildren = isLoading ? <SpinnerWhite /> : children

    const componentProps = {
      as: isLink ? (isExternalLink ? 'a' : Link) : as || 'button',
      ref,
      disableIconStyle,
      ...(isVariantLink
        ? { linksize: size, emphasis }
        : { size, buttonType, fullWidth, side }),
      ...props
    }

    if (isExternalLink) {
      componentProps.href = to
      componentProps.target = target ?? '_blank'
      componentProps.rel = 'noopener noreferrer'
    } else if (isLink) {
      componentProps.to = to
    }

    return <Component {...componentProps}> {contentChildren} </Component>
  }
)

ButtonComponent.propTypes = {
  as: PropTypes.elementType,
  variant: PropTypes.oneOf(Object.values(buttonVariantOptions)),
  size: PropTypes.string,
  side: PropTypes.string,
  buttonType: PropTypes.oneOf(Object.values(buttonTypeOptions)),
  fullWidth: PropTypes.bool,
  emphasis: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  disableIconStyle: PropTypes.bool,
  isLoading: PropTypes.bool
}

ButtonComponent.displayName = 'ButtonComponent'

export default ButtonComponent
